<template>
    <div>
        <div class="mx-auto row">
            <p class="col-12 d-block mb-0"><span class="text-danger">توجه ! </span> آگهی های یافت شده ظرف 72 ساعت آینده حذف خواهند شد.</p>
            <v-col class="col-md-4" v-for="item in  archives">
                <v-card color="#191179" dark class="text-white" max-height="300" elevation="4" :key="item.post.token">
                    <div class="d-flex flex-no-wrap justify-space-between">
                        <div>
                            <v-card-subtitle class="py-2" v-text="item.post.title"></v-card-subtitle>
                            <v-card-subtitle class="py-1" v-text="item.post.top_description_text"></v-card-subtitle>
                            <v-card-subtitle class="py-1" v-text="item.post.middle_description_text"></v-card-subtitle>
                            <v-card-subtitle class="py-1" v-text="item.post.bottom_description_text"></v-card-subtitle>
                        </div>
                        <v-avatar class="ma-3" size="115">
                            <v-img :src="item.post.images.length > 0 && item.post.images[0] !== null ? item.post.images[0] : require('@/assets/img/rblandNotext.png')"></v-img>
                        </v-avatar>
                    </div>
                </v-card>
            </v-col>
        </div>
        <atom-spinner
                v-if="loading"
                :animation-duration="1500"
                :size="100"
                class="mx-auto"
                color="indigo"
        />
        <a id="dl" ref="dl"></a>
    </div>
</template>

<script>
import {AtomSpinner} from 'epic-spinners'
export default {
    name: "divarAdvertise",
    props: {
        searchResults: {
            require: true
        },
        id: {
            default: ''
        },
    },
    components:{AtomSpinner},
    data() {
        return {
            observer: null,
            next_page: null,
            loading:false,
            archives: [],
            url: `${url}/user/recent/${this.id}/posts`
        }
    },
    methods: {
        getAds(url = this.url) {
            this.loading=true;
            $.ajax({
                url:url,
                type: 'GET',
                fn: this.relatedAction,
                headers: {
                    "ACCEPT": "application/json",
                    "Authorization": Token
                },
                msg: false,
                success: (data) => {
                    this.loading=false;
                    this.archives = this.archives.concat(data.data.data);
                    this.next_page = data?.data?.next_page_url?.replace('http://', 'https://');
                    this.next_page = data?.data?.next_page_url;
                    this.observer.observe(this.$refs.dl);
                }
            })
        }
    },
    mounted() {
        this.getAds();
        this.observer = new IntersectionObserver((entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting && this.next_page !== null) {
                    this.observer.unobserve(this.$refs.dl);
                    this.getAds(this.next_page);
                }
            });
        }));
    }
}
</script>

<style scoped>

</style>